module.exports = __webpack_public_path__ + "img/clipboard-prescription.f95cf952.svg";